export default __webpack_public_path__ + "static/media/github2.883e6914.png";